import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter, MedicalTreatment } from "@/lib/types";
import type { ReactNode } from "react";

interface MatterMedicalTreatmentContextMenuProps {
  children: ReactNode;
  matter: Matter;
  onEdit?: () => void;
  providerName?: string;
  treatment: MedicalTreatment;
}

export const MatterMedicalTreatmentContextMenu = ({
  children,
  matter,
  onEdit,
  providerName,
  treatment,
}: MatterMedicalTreatmentContextMenuProps) => {
  const entityLabel = providerName || "medical treatment";

  return (
    <MatterSubItemContextMenu
      createSignatureRequest
      copyValue={[
        entityLabel,
        treatment.type.join(", "),
        treatment.status,
        treatment.patientAccountNumber,
      ]
        .filter(Boolean)
        .join("\n")}
      entityLabel={entityLabel}
      entityName="medical treatment"
      matter={matter}
      onEdit={onEdit}
      subItem={{ id: treatment.id, type: "medical-treatment" }}
      trigger={children}
    />
  );
};
